import { CIInput, CIInputProps } from 'car-insurance/components/common/CIInput';

const FormInput: React.FC<
  { label: string; error?: string; hint?: string } & Omit<CIInputProps, 'error'>
> = ({ label, error, hint, value, ...restProps }) => {
  const showHint = Boolean(hint) && !error?.length && !value.length;

  return (
    <div className="flex grow flex-col gap-1">
      <p className="font-medium text-base text-gray-800">{label}</p>
      <CIInput
        error={Boolean(error)}
        isBold
        backgroundColor="bg-white"
        value={value}
        {...restProps}
      />
      {showHint && <p className="font-medium text-xs text-gray-800">{hint}</p>}
      {!!error && <p className="font-normal text-sm text-red-800">{error}</p>}
    </div>
  );
};
export { FormInput };
